import styled from "styled-components";
import LinearProgress from "@material-ui/core/LinearProgress";

export const Progress = styled(LinearProgress)`
  width: 90%;
  border-radius: 20px;
  height: 11px !important;
  margin: 10px 15px 10px 0px;
  background-color: #cbe1ea !important;
  .MuiLinearProgress-bar {
    background: linear-gradient(283.23deg, #23a2d9 40.49%, #346d85 105.75%);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 22px;
  }
`;
